import type { Payment } from "@kanda-libs/ks-frontend-services";
import { URLS } from "common/constants";
import { formatDate } from "common/helpers";

export interface PaymentTime {
  time: string;
  date: string;
}

export interface PaymentPropsHook {
  id?: string;
  status?: string;
  total?: number;
  method: string;
  createdAt: PaymentTime;
  updatedAt: PaymentTime;
  wrapperProps: {
    to: string;
  };
}

export default function usePaymentProps(payment: Payment): PaymentPropsHook {
  const id = payment?.id;
  const status = payment?.status;
  const total = payment?.payment_option?.amount?.amount;
  const method = payment?.payment_option?.payment_method;
  const createdAt = formatDate(payment?.metadata?.created_at as Date);
  const updatedAt = formatDate(payment?.metadata?.updated_at as Date);

  const wrapperProps = { to: URLS.PAYMENT.replace("{id}", id as string) };

  return {
    id,
    status,
    total,
    method,
    createdAt,
    updatedAt,
    wrapperProps,
  };
}
